import mod from "../lib/index.js";

export default mod;
export const Menu = mod.Menu;
export const MenuButton = mod.MenuButton;
export const MenuGroup = mod.MenuGroup;
export const MenuItem = mod.MenuItem;
export const MenuList = mod.MenuList;
export const MenuSeparator = mod.MenuSeparator;
export const MenuSeperator = mod.MenuSeperator;
